<template>
  <SearchBarWithRequestStatus
    :keyword="keyword"
    :request-status="filter.requestStatus"
    :search-result="searchResult"
    @inputKeyword="keyword = $event"
    @inputRequestStatus="onChangeRequestStatus"
    @pagination="pagination"
    @search="search"
  >
    <slot />
  </SearchBarWithRequestStatus>
</template>

<script>
import SearchBarWithRequestStatus from '@/components/Shared/Search/SearchBarWithRequestStatus'
import { actions } from '@/vuex/modules/admin/request/menu/constants'

export default {
  name: 'SearchBar',
  components: {
    SearchBarWithRequestStatus,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    searchResult: {
      type: Object,
      required: true,
    },
    systemOwnerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      keyword: '',
    }
  },
  created() {
    this.syncInputFilter()
  },
  methods: {
    onChangeRequestStatus(requestStatus) {
      this.$store.dispatch(actions.UPDATE_REQUEST_STATUS_FILTER, requestStatus)
      this.search()
    },
    async search() {
      // キーワードはこのタイミングで更新する
      this.$store.dispatch(actions.UPDATE_KEYWORD_FILTER, this.keyword)
      await this.$store.dispatch(actions.SEARCH, this.systemOwnerId)
    },
    syncInputFilter() {
      const { keyword } = this.filter
      this.keyword = keyword
    },
    pagination(event) {
      console.log('paginagtion WIP')
      console.log(event)
    },
  },
}
</script>
